"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var moment = require("moment");
var BonusTemplateLocalesListCtl = /** @class */ (function (_super) {
    __extends(BonusTemplateLocalesListCtl, _super);
    function BonusTemplateLocalesListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_key = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key; });
        _this.dk_bonus_template_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.bonus_template_id; });
        _this.dk_bonus_template_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.bonus_template_title; });
        _this.dk_app_language_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_language_id; });
        _this.dk_app_language_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_language_title; });
        _this.dk_app_currency_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_currency_id; });
        _this.dk_app_currency_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_currency_title; });
        _this.dk_wager_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.wager_title; });
        _this.dk_wager_description_tpl = UIUtils_1.UIUtils.IProp2Str(function (o) { o.wager_description_tpl; });
        _this.dk_wager_condition_tpl = UIUtils_1.UIUtils.IProp2Str(function (o) { o.wager_condition_tpl; });
        _this.dk_wager_pre_create_teaser_tpl = UIUtils_1.UIUtils.IProp2Str(function (o) { o.wager_pre_create_teaser_tpl; });
        _this.dk_wager_pre_create_teaser_img_url = UIUtils_1.UIUtils.IProp2Str(function (o) { o.wager_pre_create_teaser_img_url; });
        _this.dk_freespin_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.freespin_title; });
        _this.dk_freespin_description_tpl = UIUtils_1.UIUtils.IProp2Str(function (o) { o.freespin_description_tpl; });
        _this.dk_freespin_condition_tpl = UIUtils_1.UIUtils.IProp2Str(function (o) { o.freespin_condition_tpl; });
        _this.dk_freespin_pre_create_teaser_tpl = UIUtils_1.UIUtils.IProp2Str(function (o) { o.freespin_pre_create_teaser_tpl; });
        _this.dk_freespin_pre_create_teaser_img_url = UIUtils_1.UIUtils.IProp2Str(function (o) { o.freespin_pre_create_teaser_img_url; });
        _this.dk_bonus_template_json_test_data = UIUtils_1.UIUtils.IProp2Str(function (o) { o.bonus_template_json_test_data; });
        _this.dk_date_added = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added; });
        _this.dk_date_changed = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed; });
        _this._errDialog = errDialog;
        return _this;
    }
    BonusTemplateLocalesListCtl.prototype.ResetData = function () {
        this.DATA = {
            cdn_baseurl: "",
            data: [],
            total: 0
        };
    };
    BonusTemplateLocalesListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        throw "bonus template locale with id [" + id + "] not found !";
    };
    BonusTemplateLocalesListCtl.prototype.LoadData = function (bonusTemplateId, onDone) {
        var _this = this;
        webAApi_1.ListBonusTemplateLocalesByBonusTemplateIdGet.exec({
            bonus_template_id: bonusTemplateId
        }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            _this.DATA.cdn_baseurl = resp.cdn_baseurl;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    bonus_template_id: resp.list[i].bonus_template_id,
                    bonus_template_title: resp.list[i].bonus_template_title,
                    app_language_id: resp.list[i].app_language_id,
                    app_language_title: resp.list[i].app_language_title,
                    app_currency_id: resp.list[i].app_currency_id,
                    app_currency_title: resp.list[i].app_currency_title,
                    wager_title: resp.list[i].wager_title,
                    wager_description_tpl: resp.list[i].wager_description_tpl,
                    wager_condition_tpl: resp.list[i].wager_condition_tpl,
                    wager_pre_create_teaser_tpl: resp.list[i].wager_pre_create_teaser_tpl,
                    wager_pre_create_teaser_img_url: resp.list[i].wager_pre_create_teaser_img_url,
                    freespin_title: resp.list[i].freespin_title,
                    freespin_description_tpl: resp.list[i].freespin_description_tpl,
                    freespin_condition_tpl: resp.list[i].freespin_condition_tpl,
                    freespin_pre_create_teaser_tpl: resp.list[i].freespin_pre_create_teaser_tpl,
                    freespin_pre_create_teaser_img_url: resp.list[i].freespin_pre_create_teaser_img_url,
                    bonus_template_json_test_data: resp.list[i].bonus_template_json_test_data,
                    date_added: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed: moment(resp.list[i].date_changed_uts_ms).utc(false),
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    BonusTemplateLocalesListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddBonusTemplateLocale.exec({
            data: {
                bonus_template_id: data.bonus_template_id,
                app_language_id: data.app_language_id,
                app_currency_id: data.app_currency_id,
                wager_title: data.wager_title,
                wager_pre_create_teaser_img_url: data.wager_pre_create_teaser_img_url,
                freespin_title: data.freespin_title,
                freespin_pre_create_teaser_img_url: data.freespin_pre_create_teaser_img_url,
            }
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                date_changed: moment(resp.date_changed_uts_ms).utc(false),
                date_added: moment(resp.date_added_uts_ms).utc(false),
                app_language_id: data.app_language_id,
                app_language_title: resp.language_title,
                app_currency_id: data.app_currency_id,
                app_currency_title: resp.currency_title,
                bonus_template_title: resp.bonus_template_title,
                bonus_template_id: data.bonus_template_id,
                wager_title: data.wager_title,
                wager_description_tpl: resp.wager_description_tpl,
                wager_condition_tpl: resp.wager_condition_tpl,
                wager_pre_create_teaser_tpl: resp.wager_pre_create_teaser_tpl,
                wager_pre_create_teaser_img_url: data.wager_pre_create_teaser_img_url,
                freespin_title: data.freespin_title,
                freespin_description_tpl: resp.freespin_description_tpl,
                freespin_condition_tpl: resp.freespin_condition_tpl,
                freespin_pre_create_teaser_tpl: resp.freespin_pre_create_teaser_tpl,
                freespin_pre_create_teaser_img_url: data.freespin_pre_create_teaser_img_url,
                bonus_template_json_test_data: resp.bonus_template_json_test_data,
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    BonusTemplateLocalesListCtl.prototype.DoUpdateWagerDescriptionTpl = function (data, onDone) {
        var _this = this;
        var _tmp = this.getById(data.key);
        if (_tmp) {
            webAApi_1.DoUpdateBonusTemplateLocaleWagerDescriptionTpl.exec({
                data: {
                    bonus_template_locale_id: data.key,
                    wager_description_tpl: data.template,
                }
            }, function (resp) {
                _tmp.wager_description_tpl = data.template;
                _tmp.date_changed = moment(resp.date_changed_uts_ms).utc(false);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    BonusTemplateLocalesListCtl.prototype.DoUpdateWagerConditionTpl = function (data, onDone) {
        var _this = this;
        var _tmp = this.getById(data.key);
        if (_tmp) {
            webAApi_1.DoUpdateBonusTemplateLocaleWagerConditionTpl.exec({
                data: {
                    bonus_template_locale_id: data.key,
                    wager_condition_tpl: data.template,
                }
            }, function (resp) {
                _tmp.wager_condition_tpl = data.template;
                _tmp.date_changed = moment(resp.date_changed_uts_ms).utc(false);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    BonusTemplateLocalesListCtl.prototype.DoUpdatePreCreateWagerTeaserTpl = function (data, onDone) {
        var _this = this;
        var _tmp = this.getById(data.key);
        if (_tmp) {
            webAApi_1.DoUpdateBonusTemplateLocaleWagerPreCreateTeaserTpl.exec({
                data: {
                    bonus_template_locale_id: data.key,
                    wager_pre_create_teaser_tpl: data.template,
                }
            }, function (resp) {
                _tmp.wager_pre_create_teaser_tpl = data.template;
                _tmp.date_changed = moment(resp.date_changed_uts_ms).utc(false);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    BonusTemplateLocalesListCtl.prototype.DoRenderTemplatePreview = function (data, onDone) {
        var _this = this;
        webAApi_1.DoRenderBonusTemplateLocalePreview.exec({
            data: {
                tpl_text: data.template,
                json_data: data.data,
            }
        }, function (resp) {
            if (onDone) {
                onDone(resp.rendered_txt);
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    BonusTemplateLocalesListCtl.prototype.EditData = function (data, onDone) {
        var _this = this;
        var _tmp = this.getById(data.key);
        if (_tmp) {
            webAApi_1.DoEditBonusTemplateLocale.exec({
                data: {
                    bonus_template_locale_id: data.key,
                    app_language_id: data.app_language_id,
                    wager_title: data.wager_title,
                    wager_pre_create_teaser_img_url: data.wager_pre_create_teaser_img_url,
                    freespin_title: data.freespin_title,
                    freespin_pre_create_teaser_img_url: data.freespin_pre_create_teaser_img_url,
                    app_currency_id: data.app_currency_id
                }
            }, function (resp) {
                _tmp.app_language_id = data.app_language_id;
                _tmp.app_language_title = resp.app_language_title;
                _tmp.app_currency_id = data.app_language_id;
                _tmp.app_currency_title = resp.app_currency_title;
                _tmp.wager_title = data.wager_title;
                _tmp.wager_pre_create_teaser_img_url = data.wager_pre_create_teaser_img_url;
                _tmp.freespin_title = data.freespin_title;
                _tmp.freespin_pre_create_teaser_img_url = data.freespin_pre_create_teaser_img_url;
                _tmp.date_changed = moment(resp.date_changed_uts_ms).utc(false);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    BonusTemplateLocalesListCtl.prototype.RemoveItem = function (key) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === key) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    BonusTemplateLocalesListCtl.prototype.DeleteData = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeleteBonusTemplateLocale.exec({ data: { bonus_template_locale_id: key } }, function (resp) {
                _this.RemoveItem(key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    BonusTemplateLocalesListCtl.prototype.doCloneData = function (key, appLanguageId, appCurrencyId, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoCloneBonusTemplateLocale.exec({
                data: {
                    bonus_template_locale_id: key,
                    app_language_id: appLanguageId,
                    app_currency_id: appCurrencyId
                }
            }, function (resp) {
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return BonusTemplateLocalesListCtl;
}(BaseController_1.BaseController));
exports.BonusTemplateLocalesListCtl = BonusTemplateLocalesListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_bonus_templates/ctl/BonusTemplateLocalesListCtl.ts
// module id = 950
// module chunks = 0